<template>
  <v-card outlined>
    <v-card-title>Convenio</v-card-title>
    <v-card-subtitle>
      <v-chip small>ID: {{ convenio.id }}</v-chip>
      <v-chip small class="ml-2">DNI: {{ convenio.dniDeudor }}</v-chip>
      <v-chip small class="ml-2">CREADO: {{ getDateFormat(convenio.createdAt) }}</v-chip>
      <v-chip small class="ml-2">Primer Pago: {{ getDateFormat(convenio.fechaPrimerPago) }}</v-chip>
      <v-chip v-if="convenio.fueraDePauta" small class="ml-2 purple--text lighten-3">Fuera de Pauta</v-chip>
      <v-chip v-if="convenio.quitaEspecial" small class="ml-2 purple--text lighten-3">Quita especial</v-chip>

<!--      <v-chip v-if="convenio.vigente" small class="ml-2 green lighten-3">Vigente</v-chip>-->
<!--      <v-chip v-else small class="ml-2 red lighten-3">Inactivo: {{ getDateFormat(convenio.fechaInactivacion) }}</v-chip>-->

      <v-chip v-if="convenio.estado" small
              :class="{
        'orange': convenio.estado === 'POR VENCER',
        'green': convenio.estado === 'VIGENTE',
        'red': convenio.estado === 'CAIDO',
        'blue': convenio.estado === 'CANCELADO',
        'pink': convenio.estado === 'INACTIVO'
      }"
              class="ml-2 lighten-3">{{ convenio.estado }}
      </v-chip>
    </v-card-subtitle>

    <v-card-text class="d-flex justify-center">

      <v-row>
        <v-col cols="12" sm="4">
          <v-card outlined>
            <v-card-title class="pb-0">Plan</v-card-title>
            <v-card-text class="pb-0">
              <v-list dense width="100%">
                <v-list-item>
                  <v-list-item-content class="font-weight-bold grey--text text--darken-2">Cuotas:</v-list-item-content>
                  <v-list-item-action>{{ convenio.cuotas }}</v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold grey--text text--darken-2">Valor Cuota:
                  </v-list-item-content>
                  <v-list-item-action>{{ currency }}{{ convenio.montoCuota.toLocaleString('es-AR') }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold grey--text text--darken-2">Monto Total:
                  </v-list-item-content>
                  <v-list-item-action>{{ currency }}{{ convenio.montoTotal.toLocaleString('es-AR') }}
                  </v-list-item-action>
                </v-list-item>

              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <convenio-cobranza-card :convenio="convenio"/>
        </v-col>
        <v-col cols="12" sm="4">
          <convenio-deuda-card :convenio="convenio"></convenio-deuda-card>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text>
      <v-expansion-panels>
        <v-expansion-panel v-if="$store.getters.hasPermission('CONVENIO_VER_DEUDAS')">
          <v-expansion-panel-header><span>Deudas vinculadas</span></v-expansion-panel-header>
          <v-expansion-panel-content>
            <deuda-combobox :value="convenio.deudas.map(i => i.id)"
                            multiple
                            :dni-deudor="convenio.dniDeudor"
                            :cuil-deudor="convenio.cuilDeudor"
                            table-view
                            only-active
                            readonly
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel v-if="$store.getters.hasPermission('CONVENIO_VER_COBRANZAS')">
          <v-expansion-panel-header>Cobranzas vinculadas</v-expansion-panel-header>
          <v-expansion-panel-content>
            <cobranza-combobox v-if="convenio.cobranzas" :value="convenio.cobranzas.map(i => i.id)"
                               multiple
                               :dni-deudor="convenio.dniDeudor"
                               :cuil-deudor="convenio.cuilDeudor"
                               :propias="true"
                               table-view
                               only-active
                               readonly
            />
            <span v-else class="grey--text font-italic">No hay cobranzas vinculadas</span>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>


    </v-card-text>


    <v-card-text v-if="convenio.pagos">
      <v-card outlined>
        <v-card-title>Cuotas</v-card-title>
        <v-card-subtitle>
          <v-chip class="mr-2"> Monto total: {{ currency }}{{ convenio.montoTotal.toLocaleString('es-AR') }}</v-chip>
          <v-chip class="mr-2">Monto Vencido: {{ currency }}{{ montoVencido.toLocaleString('es-AR') }}</v-chip>
            <v-chip v-if="$store.getters.hasPermission('CONVENIO_MONTO_COBRADO')" >Monto Cobrado: {{ currency }}{{ montoCobrado.toLocaleString('es-AR') }}</v-chip>
        </v-card-subtitle>

        <v-card-text v-if="$store.getters.hasPermission('CONVENIO_MONTO_COBRADO')">
          <v-progress-linear
              :value="porcentajeCobradoSobreVencido"
              :buffer-value="100"
              height="50" striped color="amber"
          >
            <span class="font-weight-bold">Monto Cobrado {{
                currency
              }}{{ montoCobrado.toLocaleString('es-AR') }} ({{ porcentajeCobradoSobreVencido }}%)</span>

          </v-progress-linear>
        </v-card-text>

        <v-card-text>
          <v-simple-table>
            <thead>
            <tr>
              <th>Cuota</th>
              <th>Vencimiento</th>
              <th>Valor Cuota</th>
              <th>Pago Informado</th>
              <th>Estado</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(pago,i) in pagosCuota" :key="i" :class="pagoColor(pago)">
              <td>{{ pago.cuota }}</td>
              <td>{{ getDateFormat(pago.fechaVencimiento) }}</td>
              <td>{{ currency }}{{ pago.monto.toLocaleString('es-AR') }}</td>
              <td>{{ pago.pagado ? 'Si' : 'No' }}</td>
              <td>{{ pagoEstado(pago) }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

      </v-card>

      <v-card class="mt-2" outlined>
        <v-card-title>Pagos Parciales</v-card-title>
        <v-card-text v-if="pagosParciales.length > 0">
          <v-simple-table>
            <thead>
            <tr>
              <th>Fecha Pago</th>
              <th>Monto</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(pago,i) in pagosParciales" :key="i">
              <td>{{ getDateFormat(pago.fechaComprobante) }}</td>
              <td>{{ currency }}{{ pago.monto.toLocaleString('es-AR') }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-text v-else>
          <v-alert type="info">No hay pagos parciales registrados</v-alert>
        </v-card-text>
      </v-card>

    </v-card-text>

    <v-card-text v-if="convenio.exito">
      <v-card outlined>
        <v-card-title class="pb-0">Datos EXITO</v-card-title>
        <v-card-text>
          <v-simple-table>
            <tbody>
            <tr>
              <th>Nombre</th>
              <td>{{ convenio.exito.nombre }}</td>
            </tr>
            <tr>
              <th>Email</th>
              <td>{{ convenio.exito.email }}</td>
            </tr>
            <tr>
              <th>Telefono</th>
              <td>{{ convenio.exito.telefono }}</td>
            </tr>
            <tr>
              <th>IP</th>
              <td>{{ convenio.exito.ip }}</td>
            </tr>
            <tr>
              <th>UserAgent</th>
              <td>{{ convenio.exito.userAgent }}</td>
            </tr>
            </tbody>

          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-card-text>

  </v-card>
</template>
<script>
import ConvenioCobranzaCard from "@/modules/cobrox/components/ConvenioCard/ConvenioCobranzaCard.vue"
import ConvenioDeudaCard from "@/modules/cobrox/components/ConvenioCard/ConvenioDeudaCard.vue"
import CurrencyMixin from "@/modules/cobrox/mixins/CurrencyMixin";
import {DayjsMixin} from "@dracul/dayjs-frontend";
import DeudaCombobox from "@/modules/cobrox/combobox/DeudaCombobox";
import CobranzaCombobox from "@/modules/cobrox/combobox/CobranzaCombobox";
import dayjs from "dayjs";

export default {
  name: 'convenio-card',
  components: {CobranzaCombobox, DeudaCombobox, ConvenioCobranzaCard, ConvenioDeudaCard},
  mixins: [CurrencyMixin, DayjsMixin],
  props: {
    convenio: {type: Object}
  },
  computed: {
    pagosCuota() {
      return this.convenio.pagos.filter(p => !p.parcial)
    },
    pagosParciales() {
      return this.convenio.pagos.filter(p => p.parcial === true)
    },
    montoVencido() {
      const today = dayjs();
      return this.convenio.pagos
          .filter(pago => today.isAfter(dayjs(pago.fechaVencimiento)))
          .reduce((total, cobranza) => total + cobranza.monto, 0)
    },
    montoCobrado() {
      return this.convenio.cobranzas.reduce((total, cobranza) => total + cobranza.montoCobrado, 0)
    },
    porcentajeCobradoSobreVencido() {
      if (this.montoVencido === 0) return 0;
      const porcentaje = (this.montoCobrado / this.montoVencido) * 100;
      // Usar Math.floor para evitar redondeos que muestren 100% cuando no lo es
      return Math.min(Math.floor(porcentaje * 100) / 100, 100);
    },
    pagoImputado() {
      return pago => {
        let monto = pago.cuota * pago.monto
        return this.montoCobrado >= monto
      }
    },
    pagoEstado() {
      return pago => {
        if (this.pagoImputado(pago)) {
          return 'Cobrado'
        } else {
          const vencimiento = dayjs(pago.fechaVencimiento)
          if (dayjs().isBefore(vencimiento)) {
            return 'Pendiente'
          } else {
            return 'Vencido'
          }
        }
      }
    },
    pagoColor() {
      return pago => {
        switch (this.pagoEstado(pago)) {
          case 'Pendiente':
            return 'grey lighten-4'
          case 'Vencido':
            return 'red lighten-4'
          case 'Cobrado':
            return 'green lighten-4'
          default:
            return ''
        }
      }
    }
  }
}
</script>
